module.exports = "/assets/data/bba56f2f8b9e635d7ad665a60afd88da-L21.data.json";